import { useEffect } from 'react';
import { useNavSize } from '@frontend/responsiveness';
import { useSettingsPanelStore } from '@frontend/settings-panel-engine';
import { useInterRouter } from '@frontend/settings-routing';

export const useSettingsNavSize = () => {
  const { setIsSettingsMenuOpen, isSettingsMenuOpen, isSettingsOpen } = useInterRouter([
    'setIsSettingsMenuOpen',
    'isSettingsMenuOpen',
    'isSettingsOpen',
  ]);
  const navState = useSettingsPanelStore((state) => state.navState);

  const navSize = useNavSize();
  const isDesktopAndMenuOpen = navSize.isGte('large') && isSettingsMenuOpen;

  useEffect(() => {
    if (isDesktopAndMenuOpen || !isSettingsOpen) {
      setIsSettingsMenuOpen(false);
    }
  }, [isDesktopAndMenuOpen, isSettingsOpen, setIsSettingsMenuOpen]);

  const isSmallerThanDesktop = navSize.isLt('large') || navState === 'collapsed';
  const isMini = navSize.isGte('small') && navSize.isLte('mobile');

  return { navSize: navSize.size, isSmallerThanDesktop, isMini };
};
